const JUST_HOSTS = new Set([
  'just.ac',
  'www.just.ac',
  'my.just.ac',
  'tv.just.ac',
]);

export const MAIN_SITE_URL = 'https://performerai.ru';

export const isJustDomain = (hostname = window.location.hostname) => {
  const host = hostname.toLowerCase().replace(/:\d+$/, '');
  return JUST_HOSTS.has(host);
};
